import React, { useState, useEffect, useContext } from 'react'
import Box from '@mui/material/Box'
import ProfileHeader from '../../../components/ProfileHeader'
import { getNotificationsByUser,deleteNotifications,patchNotifications } from '../../../api/NotificationsApi'
import ProfileBottomNav from '../../../components/ProfileBottomNav'
import {
  DataGridPremium,
  GridColDef,
  GridToolbarFilterButton,
  useGridRootProps,
  GridToolbarProps,
  GridToolbarContainer,
  esES,
  GridRenderCellParams,
  getGridStringOperators,
  GridFilterOperator,
} from '@asf-libs/x-data-grid-premium'
import ProfileContext from '../profile/ProfileContext'
import { Trans } from 'react-i18next'
import { USER_SO_KEY } from '../../../utils/accountUtils'
import { getSessionStorage } from '../../../utils/StorageUtil'
import moment from 'moment'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import MarkEmailUnread from '@mui/icons-material/MarkEmailUnread'
import Drafts from '@mui/icons-material/Drafts'
import Dialog from '@mui/material/Dialog'
import Divider from '@mui/material/Divider'
import DeleteIcon from '@mui/icons-material/Delete';

const CustomToolbar = React.forwardRef<HTMLDivElement, GridToolbarProps>(
  function GridToolbar(props, ref) {
    const { className, csvOptions, printOptions, ...other } = props
    const rootProps = useGridRootProps()

    if (
      rootProps.disableColumnFilter &&
      rootProps.disableColumnSelector &&
      rootProps.disableDensitySelector
    ) {
      return null
    }

    return (
      <GridToolbarContainer
        sx={{ background: '#F2F3F1', border: 0, width: '100%' }}
        ref={ref}
        {...other}
      >
        <Box className="indicators-title">
          <Trans i18nKey={`screens.indicators.titleListNotification`}></Trans>

          <GridToolbarFilterButton sx={{ ml: 10 }} />
        </Box>
      </GridToolbarContainer>
    )
  }
)

export default function Notifications() {
  const user = getSessionStorage(USER_SO_KEY);
  const [rows, setRows] = useState([]);
  // const [filterValue, setFilterValue] = useState();
  const [refreshNotification, setRefreshNotification] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [notification, setNotification] = useState(null);

  const handleRowClick=async (row:any)=>{
    const body={
      id: row.id,
      isRead: true
    }
   await patchNotifications(row.id ,body)
    setNotification(row);
    setShowModal(true);
    setRefreshNotification(!refreshNotification)

  }

  
  const handleDelete= async (id:any)=>{
   await deleteNotifications(id);
   setRefreshNotification(!refreshNotification);
    closeModal();
  }

  console.log('getGridStringOperators() ',getGridStringOperators())
  const getColumns = (role: any) => {
    let columns: GridColDef[]
   // const stringOperators = getGridStringOperators().filter((op => ['isAnyOf'].includes(op.value)));

    columns = [
      {
        field: 'isRead',
        headerName: 'Leído',
        type: 'singleSelect',
      
        valueOptions: ['Leído', 'No Leído'],
        width: 45,
        renderCell: (params: GridRenderCellParams<any>) => {
          return (
            <strong>
              <IconButton
                className="primary text"
                size="small"
                tabIndex={params.hasFocus ? 0 : -1}
                onClick={() => handleRowClick(params.row)}
              >
                {params.row.isRead == 'Leído' ? (
                  <Drafts></Drafts>
                ) : (
                  <MarkEmailUnread />
                )}
              </IconButton>
            </strong>
          )
        },
      },
      {
        field: 'title',
        headerName: 'Titulo',
        width: 300,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'center',
        align: 'left',
      },
      // {
      //   field: 'message',
      //   headerName: 'Mensaje',
      //   width: 250,
      //   headerClassName: 'super-app-theme--header',
      //   headerAlign: 'center',
      //   align: 'center',
      // },
      {
        field: 'creationDate',
        headerName: 'Fecha',
        width: 150,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'center',
        align: 'center',
      },
    ]

    return columns
  }



  

  useEffect(() => {
    let active = true;

    (async () => {
      setLoading(true)
      await getNotificationsByUser()
        .then((response) => {
          const dataRows = response?.data?.map((d: any, index: number) => {
            return {
              id: d.id,
              title: d.title,
              message: d.message,
              creationDate: moment(d.creationDate).format('DD/MM/YYYY'),
              isRead: d.isRead ? 'Leído' : 'No Leído',
            }
          })
          setRows(dataRows ? dataRows : [])
        })
        .catch((e) => {
          console.log('Error', e)
        })

      if (!active) {
        return
      }
      setLoading(false)
    })()

    return () => {
      active = false
    }
  }, [refreshNotification])

  function closeModal() {
    setNotification(null);
    setShowModal(false)
  }

  return (
    <ProfileContext.Consumer>
      {(context) => {
        const userData = context.userData
        return (
          <Box sx={{ background: '#F2F3F1' }}>
            <ProfileHeader></ProfileHeader>
            <Box sx={{ margin: '0 4%' }}>
              <Box
                borderRadius={5}
                sx={{
                  background: '#FFFFFF',
                  height: (rows?.length + 1) * 50 + 200,
                  pt: 1,
                }}
              >
                <DataGridPremium
                  localeText={
                    esES.components.MuiDataGrid.defaultProps.localeText
                  }
                  rows={rows}
                  columns={getColumns(user.role)}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                  slotProps={{
                    filterPanel: {
                      disableRemoveAllButton: true,
                    },
                  }}
                  sx={{
                    border: 0,
                    '& .super-app-theme--header': {
                      fontWeight: '900',
                    },
                  }}
                />
              </Box>

              <Dialog
                open={showModal}
                onClose={closeModal}
                className="ticket-form-succes-dialog"
                sx={{ '& .MuiDialog-paper': { width: '300px', maxHeight: 435 } }}
                maxWidth="xs"
                fullWidth
              >
                <Box>
                  <Box sx={{ margin: '0 9%'  }} py={6}>
                    <Box className="ticket-form-succes-dialog-title">
                    <strong>
              <IconButton
                className="primary text"
                size="small"
               
              >
                {notification?.isRead == 'Leído' ? (
                  <Drafts></Drafts>
                ) : (
                  <MarkEmailUnread />
                )}
              </IconButton>
            </strong>
                  
                      {notification?.title}
                    </Box>
                    <br></br>
                    <Box>
                    {notification?.message}
                    </Box>
                  </Box>
                  <Divider />
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-around',
                      margin: '12px 9%',
                    }}
                  >
                    <Button onClick={()=>handleDelete(notification?.id)}
                     variant="text" startIcon={<DeleteIcon />}>
                      Eliminar
                    </Button>
                    {/* <Button
                      onClick={() => alert('sadfas')}
                      className="sec-btn"
                      variant="contained"
                      color="error"
                    >
                      Rechazar
                    </Button> */}
                     <Button
                      className="sec-btn"
                      variant="contained"
                      color="primary"
                     onClick={closeModal} >
                      Cerrar
                    </Button>
                  </Box>
                </Box>
              </Dialog>
            </Box>
            <ProfileBottomNav goBack={true}></ProfileBottomNav>
          </Box>
        )
      }}
    </ProfileContext.Consumer>
  )
}
